import apiClient from "../api/client";

export const UserService = {
  async getUsers(params?: any) {
    const response = await apiClient.get("/users/", { params });
    return response;
  },

  async createUser(data: any) {
    const response = await apiClient.post("/users/", data);
    return response;
  },

  async updateUser(id: string, data: any) {
    const response = await apiClient.patch(`/users/${id}/`, data);
    return response;
  },

  async deleteUser(id: string) {
    const response = await apiClient.delete(`/users/${id}/`);
    return response;
  },
  
  async getCurrentUser() {
    const response = await apiClient.get("/users/me/");
    return response;
  },

  async validateFournisseur(id: string) {
    const response = await apiClient.post(`/users/${id}/valider/`);
    return response;
  }
};
